import api, { Pagination } from '..'

export interface ReimbursementListFilters {
  status?: string
  from?: string
  to?: string
  search?: string
  organizationId?: string
}

export class ReimbursementService {
  static async findAll(
    pagination: Pagination,
    filters: ReimbursementListFilters = {}
  ) {
    const response = await api.get('/reimbursements/list', {
      params: {
        page: pagination.page,
        perPage: pagination.perPage,
        status: filters.status || '',
        from: filters.from || '',
        to: filters.to || '',
        search: filters.search || '',
        organizationId: filters.organizationId || ''
      }
    })
    return response.data
  }

  static async verifyKkiapay(id: string) {
    const response = await api.get(`/reimbursements/${id}/verify-kkiapay`)
    return response.data
  }

  static async checkStatus(id: string) {
    const response = await api.post(`/reimbursements/${id}/check-status`)
    return response.data
  }

  static async findByBeneficiaryGroup(
    beneficiaryGroupId: string,
    productId?: string
  ) {
    const response = await api.get('/reimbursements', {
      params: {
        beneficiaryGroupId,
        populate: 'transaction,beneficiary',
        sort: 'createdAt',
        ...(productId ? { productId } : {})
      }
    })
    return response.data
  }
}
